module.exports = __webpack_public_path__ + "img/platform-hp-reverb.25c9e5ec.png";